import type {
  GridColumnInfo,
  GridInputTablePickerOptions,
  GridOptions,
} from '../types'

type InputTableOptions = GridInputTablePickerOptions &
  Partial<Pick<GridOptions, 'toolbar' | 'editable' | 'newBtn' | 'delBtn'>>

export const LOV_PICKER_VALUE_FIELD = 'lovValue'
export const LOV_PICKER_TITLE_FIELD = 'lovTitle'

/** LOV 列编辑弹窗内 ZGrid 配置 */
export function resolveLovInputTableOptions(
  column: GridColumnInfo
): InputTableOptions {
  return {
    module: '',
    lovType: column.lovType,
    valueField: LOV_PICKER_VALUE_FIELD,
    columns: [
      {
        field: LOV_PICKER_TITLE_FIELD,
        title: column.title ?? '名称',
        type: 'base',
      },
      {
        field: LOV_PICKER_VALUE_FIELD,
        title: '值',
        type: 'base',
      },
    ],
  }
}

/** LOV 列 map：表单字段 -> 弹窗 lovValue / lovTitle */
export function resolveLovInputTableMap(
  column: GridColumnInfo
): Record<string, string> {
  if (column.map && Object.keys(column.map).length) {
    return column.map
  }
  const field = column.field
  if (!field) {
    return {}
  }
  return {
    [field]: LOV_PICKER_VALUE_FIELD,
    [`${field}Name`]: LOV_PICKER_TITLE_FIELD,
  }
}

/** table 列 map（必填）：行字段 -> 弹窗表格列字段 */
export function resolveTableInputTableMap(
  column: GridColumnInfo
): Record<string, string> {
  return column.map ?? {}
}

/** table 列编辑弹窗内 ZGrid 配置 */
export function resolveTableInputTableOptions(
  column: GridColumnInfo
): InputTableOptions {
  const pickerOptions = column.options ?? { columns: [] }
  return {
    ...pickerOptions,
    module: pickerOptions.module ?? '',
    columns: pickerOptions.columns ?? [],
    toolbar: pickerOptions.toolbar ?? true,
    valueField: resolveTablePickerValueField(column),
    beforeOpen: column.beforeOpen ?? pickerOptions.beforeOpen,
  }
}

/** table 列 v-model / 输入框展示所对应的弹窗列字段 */
export function resolveTablePickerValueField(column: GridColumnInfo): string {
  const field = column.field
  if (!field) {
    return 'id'
  }
  const map = resolveTableInputTableMap(column)
  if (map[field]) {
    return map[field]
  }
  return field
}

/** LOV / table 列展示字段：map 中非 value 字段对应的行字段 */
export function resolveLovDisplayField(column: GridColumnInfo): string | undefined {
  const field = column.field
  if (!field) {
    return undefined
  }
  if (column.type === 'table') {
    const map = resolveTableInputTableMap(column)
    const pickerField = map[field]
    if (pickerField && pickerField !== 'id') {
      return field
    }
    const displayField = Object.entries(map).find(
      ([, pickerCol]) => pickerCol !== 'id'
    )?.[0]
    if (displayField) {
      return displayField
    }
    return field
  }
  const map = resolveLovInputTableMap(column)
  const lovTitleField = Object.entries(map).find(
    ([, pickerField]) => pickerField === LOV_PICKER_TITLE_FIELD
  )?.[0]
  if (lovTitleField) {
    return lovTitleField
  }
  const displayField = Object.entries(map).find(([sourceKey]) => sourceKey !== field)?.[0]
  if (displayField) {
    return displayField
  }
  return `${field}Name`
}
